import React, { useState, useEffect, useRef } from 'react';
import { func, number, bool } from 'prop-types';
import validator from 'validator';

import { ALERT_TYPE, Loading, PATTERNS, REQUEST_METHOD, ShowToastMessage, useForm } from '@laramie/ui';
import { APIS } from '../../../config/apis';
import { ServerRequest } from '../../../utils/apiweb';
import { FormLabel, InputSecret, Modal, Select, FormError } from '../../common'
import { VALIDATION_MESSAGE } from '../../../consts/validationMessage';
import { useFormErrors } from '../../hooks/useFormErrors';
import { InputEntidad } from '../../common'
import { validatePassword } from '../../../utils/validator';
import FirmaHolografaDefault from '../../../assets/images/FirmaHolografaDefault.png';
import {TIPS} from '../../../consts/tips';


const UsuarioModal = (props) => {

  const refInputFileFoto = useRef(null);
  // El nombre de antes de una tecla muerta o un IME: si la letra compuesta no es válida, el campo vuelve a él.
  const nombreAntesDeComponer = useRef('');

  //variables
  const entityInit = {
    id: 0,
    idTipoUsuario: 0,
    idEstadoUsuario: 0,
    idPersona: 0,
    codigo: '',
    nombreApellido: '',
    email: '',
    fechaAlta: null,
    fechaBaja: null,
    identificadorFirmaDigital: '',
    imagenFirmaDigital: '',
    password1: '',
    password2: '',
    idOficina: 0,
  };

  //hooks
  const [state, setState] = useState({
    loading: false,
    entity: entityInit,
    lists: {
      TipoUsuario: [],
      EstadoUsuario: [],
    }
  });

  const [usuarios, setUsuarios] = useState([]);

  const mount = () => {

    if (props.id > 0) {
      FindUsuario();
    }
    SearchListas();

    if (props.data.listUsuarios.length > 0) {
      setUsuarios(props.data.listUsuarios)
    }

    const unmount = () => {}
    return unmount;
  }
  useEffect(mount, []);

  const [ formValues, formHandle, formReset, formSet ] = useForm({
    idTipoUsuario: 0,
    idEstadoUsuario: 0,
    codigo: '',
    nombreApellido: '',
    email: '',
    identificadorFirmaDigital: '',
    imagenFirmaDigital: '',
    password1: '',
    password2: '',
    idOficina: 0,
  });

  const { errorOf, validate } = useFormErrors(getErrors, getFormatErrors);

  //handles
  const handleClickAceptar = () => {
    if (!validate()) return;

    if (props.id === 0) {
      AddUsuario();
    }
    else {
      ModifyUsuario();
    }
  };

  const handleInputFileFotoChange = (event) => {
    if (event.target.files.length === 0) {
        event.preventDefault();
        return;
    }

    let file = event.target.files[0];
    let reader = new FileReader();

    reader.onload = (e) => {
        const urlData = e.target.result;
        formSet({...formValues, imagenFirmaDigital: urlData});
    }
    reader.onerror = (error) => {
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error);
    }

    reader.readAsDataURL(file);
    event.target.value = "";
  }

  const handleClickRermoveFoto = () => {
    formSet({...formValues, imagenFirmaDigital: ""});
  }

  //callbacks
  const callbackNoSuccess = (response) => {
      response.json()
      .then((error) => {
        const message = error.message;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
          return {...prevState, loading: false};
        });
      })
      .catch((error) => {
          const message = 'Error procesando respuesta: ' + error;
          ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
          setState(prevState => {
            return {...prevState, loading: false};
          });
      });
  }
  const callbackError = (error) => {
      const message = 'Error procesando solicitud: ' + error.message;
      ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
      setState(prevState => {
        return {...prevState, loading: false};
      });
  }

  //funciones
  function getErrors() {

    const errors = {};

    if (formValues.idTipoUsuario <= 0) errors.idTipoUsuario = VALIDATION_MESSAGE.REQUIRED_OPTION;
    if (formValues.idEstadoUsuario <= 0) errors.idEstadoUsuario = VALIDATION_MESSAGE.REQUIRED_OPTION;
    if (formValues.idOficina <= 0) errors.idOficina = VALIDATION_MESSAGE.REQUIRED_OPTION;

    if (formValues.codigo.length === 0) errors.codigo = VALIDATION_MESSAGE.REQUIRED;
    else if (usuarios.includes(formValues.codigo.toLowerCase())) errors.codigo = 'El código de usuario ya existe';

    if (formValues.nombreApellido.length === 0) errors.nombreApellido = VALIDATION_MESSAGE.REQUIRED;
    if (formValues.email.length === 0) errors.email = VALIDATION_MESSAGE.REQUIRED;

    if (props.id === 0 && formValues.password1.length === 0) errors.password1 = VALIDATION_MESSAGE.REQUIRED;

    if ((props.id === 0 || formValues.password1.length > 0) && formValues.password2.length === 0) errors.password2 = VALIDATION_MESSAGE.REQUIRED;
    else if (formValues.password1 !== formValues.password2) errors.password2 = 'Las contraseñas no coinciden';

    return errors;
  }

  function getFormatErrors() {

    const errors = {};

    if (formValues.email.length > 0 && !validator.isEmail(formValues.email)) errors.email = 'Ingresá un correo válido';

    if (formValues.password1.length > 0) {
      const validation = validatePassword(formValues.password1);
      if (!validation.success) errors.password1 = validation.message;
    }

    return errors;
  }

  function FindUsuario() {
    
    setState(prevState => {
      return {...prevState, loading: true};
    });

    const callbackSuccess = (response) => {
        response.json()
        .then((data) => {
            setState(prevState => {
              return {...prevState, loading: false, entity: data};
            });
            formSet({...formValues,
              idTipoUsuario: data.idTipoUsuario,
              idEstadoUsuario: data.idEstadoUsuario,
              codigo: data.codigo,
              nombreApellido: data.nombreApellido,
              email: data.email,
              identificadorFirmaDigital: data.identificadorFirmaDigital,
              imagenFirmaDigital: data.imagenFirmaDigital,
              idOficina: data.idOficina,
              password1: '',
              password2: ''
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
              return {...prevState, loading: false};
            });
        });
    };

    const paramsUrl = `/${props.id}`;

    ServerRequest(
        REQUEST_METHOD.GET,
        null,
        true,
        APIS.URLS.USUARIO,
        paramsUrl,
        null,
        callbackSuccess,
        callbackNoSuccess,
        callbackError
    );

  }

  function AddUsuario() {
    const method = REQUEST_METHOD.POST;
    const paramsUrl = null;
    SaveUsuario(method, paramsUrl);
  }

  function ModifyUsuario() {
    const method = REQUEST_METHOD.PUT;
    const paramsUrl = `/${props.id}`;
    SaveUsuario(method, paramsUrl);
  }

  function SaveUsuario(method, paramsUrl) {

    setState(prevState => {
      return {...prevState, loading: true};
    });

    const callbackSuccess = (response) => {
      response.json()
      .then((row) => {
        setState(prevState => {
            return {...prevState, loading: false};
        });
        props.onConfirm(row.id);
      })
      .catch((error) => {
        const message = 'Error procesando respuesta: ' + error;
        ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
        setState(prevState => {
          return {...prevState, loading: false};
        });
      });
    };

    const dataBody = {
      ...state.entity,
      idTipoUsuario: parseInt(formValues.idTipoUsuario),
      idEstadoUsuario: parseInt(formValues.idEstadoUsuario),
      codigo: formValues.codigo,
      nombreApellido: formValues.nombreApellido,
      email: formValues.email,
      identificadorFirmaDigital: formValues.identificadorFirmaDigital,
      imagenFirmaDigital: formValues.imagenFirmaDigital,
      password: formValues.password1,
      idOficina: formValues.idOficina
    };

    ServerRequest(
        method,
        null,
        true,
        APIS.URLS.USUARIO,
        paramsUrl,
        dataBody,
        callbackSuccess,
        callbackNoSuccess,
        callbackError
    );

  }

  function SearchListas() {

    setState(prevState => {
        return {...prevState, loading: true};
    });

    const callbackSuccess = (response) => {
        response.json()
        .then((data) => {
            setState(prevState => {
                return {...prevState, loading: false, lists: data};
            });
        })
        .catch((error) => {
            const message = 'Error procesando respuesta: ' + error;
            ShowToastMessage(ALERT_TYPE.ALERT_ERROR, message);
            setState(prevState => {
                return {...prevState, loading: false};
            });
        });
    };

    const paramsUrl = '/TipoUsuario&EstadoUsuario';

    ServerRequest(
        REQUEST_METHOD.GET,
        null,
        true,
        APIS.URLS.LISTA,
        paramsUrl,
        null,
        callbackSuccess,
        callbackNoSuccess,
        callbackError
    );

  }

  function getFoto(foto) {
    if (foto.length > 0)
        return foto;
    else
        return FirmaHolografaDefault;
  }

  return (
    <>

    <Loading visible={state.loading}></Loading>

    <Modal
      size="lg"
      title={`Usuario/a: ${(props && props.id > 0) ? state.entity.nombreApellido : "Nuevo"}`}
      tipName={TIPS.NAME.MODALS.USUARIO_MODAL}
      onEscape={() => props.onDismiss()}
      body={(
            <div className="row">
                
                <div className="col-3">
                    <FormLabel htmlFor="idTipoUsuario" required>Tipo</FormLabel>
                    <Select
                        name="idTipoUsuario"
                        className={`form-control ${errorOf('idTipoUsuario') ? 'is-invalid' : ''}`}
                        value={ formValues.idTipoUsuario }
                        onChange={ formHandle }
                        disabled={props.disabled}
                        options={state.lists.TipoUsuario.map((item) => ({ value: item.id, label: item.nombre }))}
                    />
                    <FormError message={errorOf('idTipoUsuario')} />
                </div>
                <div className="col-3">
                    <FormLabel htmlFor="idEstadoUsuario" required>Estado</FormLabel>
                    <Select
                        name="idEstadoUsuario"
                        className={`form-control ${errorOf('idEstadoUsuario') ? 'is-invalid' : ''}`}
                        value={ formValues.idEstadoUsuario }
                        onChange={ formHandle }
                        disabled={props.disabled}
                        options={state.lists.EstadoUsuario.map((item) => ({ value: item.id, label: item.nombre }))}
                    />
                    <FormError message={errorOf('idEstadoUsuario')} />
                </div>
                <div className="col-6">
                    <FormLabel htmlFor="codigo" required>Usuario</FormLabel>
                    <input
                        name="codigo"
                        type="text"
                        placeholder="Código"
                        className={`form-control ${errorOf('codigo') ? 'is-invalid' : ''}`}
                        value={ formValues.codigo }
                        onChange={ formHandle }
                        disabled={props.disabled}
                    />
                    <FormError message={errorOf('codigo')} />
                </div>
                <div className="col-6">
                    <FormLabel htmlFor="nombreApellido" required>Nombre y apellido</FormLabel>
                    <input
                        name="nombreApellido"
                        type="text"
                        placeholder="Nombre y apellido"
                        className={`form-control ${errorOf('nombreApellido') ? 'is-invalid' : ''}`}
                        value={ formValues.nombreApellido }
                        onChange={({target, nativeEvent}) =>{
                          // Una tecla muerta (´ ¨ en una Mac) o un IME escribe primero una marca provisoria que el
                          // filtro no admite, y sacarla corta la composición: la letra llegaría sin su tilde. Mientras
                          // se compone, el valor queda como lo deja el navegador; el filtro se aplica al terminar.
                          if (nativeEvent.isComposing || target.validity.valid) {
                              formSet({...formValues, nombreApellido: target.value});
                          }
                        }}
                        onCompositionStart={() => { nombreAntesDeComponer.current = formValues.nombreApellido; }}
                        onCompositionEnd={({target}) => {
                          formSet({...formValues, nombreApellido: target.validity.valid ? target.value : nombreAntesDeComponer.current});
                        }}
                        disabled={props.disabled}
                        pattern={PATTERNS.onlyLettersWithSpace}
                    />
                    <FormError message={errorOf('nombreApellido')} />
                </div>
                <div className="col-6">
                    <FormLabel htmlFor="email" required>Email</FormLabel>
                    <input
                        name="email"
                        type="text"
                        placeholder="Email"
                        className={`form-control ${errorOf('email') ? 'is-invalid' : ''}`}
                        value={ formValues.email }
                        onChange={ formHandle }
                        disabled={props.disabled}
                    />
                    <FormError message={errorOf('email')} />
                </div>
                <div className="col-6">
                    <label htmlFor="identificadorFirmaDigital" className="form-label">Identificador de firma digital</label>
                    <input
                        name="identificadorFirmaDigital"
                        type="text"
                        placeholder="Identificador de Firma Digital"
                        className="form-control"
                        value={ formValues.identificadorFirmaDigital }
                        onChange={ formHandle }
                        disabled={props.disabled}
                    />
                    <FormError />
                </div>
                <div className='img-content img-foto align-center mb-3 col-6'>
                    <img
                        src={getFoto(formValues.imagenFirmaDigital)}
                        alt="Firma hológrafa"
                        className='img-fluid img-foto-size'
                        onClick={(event) => {
                            if (!props.disabled) {
                                refInputFileFoto.current.click();
                            }
                        }}
                    />
                    {(!props.disabled && formValues.imagenFirmaDigital.length > 0 &&
                    <div onClick={ (event) => handleClickRermoveFoto() } className="link">
                        <span className="material-symbols-outlined" title="Quitar imagen">close</span>
                    </div>
                    )}

                    <input
                        ref={refInputFileFoto}
                        type="file"
                        multiple={false}
                        hidden
                        onChange={handleInputFileFotoChange}
                    />
                </div>
                <div className="col-12">
                  <FormLabel htmlFor="oficina" required>Oficina</FormLabel>
                  <InputEntidad
                      name="idOficina"
                      placeholder=""
                      className={`form-control ${errorOf('idOficina') ? 'is-invalid' : ''}`}
                      value={formValues.idOficina}
                      disabled={props.disabled}
                      onChange={formHandle}
                      title="Oficina"
                      tipName={TIPS.NAME.MODALS.OFICINA_MODAL}
                      entidad="Oficina"
                  />
                  <FormError message={errorOf('idOficina')} />
                </div>
                <div className="col-6">
                    <InputSecret
                        title="Nueva contraseña"
                        name="password1"
                        value={ formValues.password1 }
                        onChange={ formHandle }
                        disabled={props.disabled}
                        autoComplete="new-password"
                        required={props.id === 0}
                        invalid={!!errorOf('password1')}
                    />
                    <FormError message={errorOf('password1')} />
                </div>
                <div className="col-6">
                    <InputSecret
                        title="Repetir contraseña"
                        name="password2"
                        value={ formValues.password2 }
                        onChange={ formHandle }
                        disabled={props.disabled}
                        autoComplete="new-password"
                        required={props.id === 0 || formValues.password1.length > 0}
                        invalid={!!errorOf('password2')}
                    />
                    <FormError message={errorOf('password2')} />
                </div>
            </div>
      )}
      footer={!props.disabled ? (<>
              <button className="btn btn-outline-primary" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Cancelar</button>
              <button className="btn btn-primary" data-dismiss="modal" onClick={ (event) => handleClickAceptar() }>Aceptar</button>
      </>) : (
              <button className="btn back-button" data-dismiss="modal" onClick={ (event) => props.onDismiss() }>Volver</button>
      )}
      footerClassName={props.disabled ? 'f-align' : ''}
    />

    </>
  );
}

UsuarioModal.propTypes = {
  id: number.isRequired,
  disabled: bool,
  onConfirm: func.isRequired,
  onDismiss: func.isRequired,
};

UsuarioModal.defaultProps = {
  disabled: false
};

export default UsuarioModal;